import { createAction, props } from '@ngrx/store';
import { Office } from '../../models';

export const LoadOffices = createAction('[People] Load Offices');
export const LoadOfficesSuccess = createAction('[People] Load Offices Success', props<{ Offices: Office[] }>());
export const LoadOfficesFail = createAction('[People] Load Offices Fail', props<{ error: any }>());
